<script setup lang="ts">
// all you need to know
// https://vuejs.org/guide/built-ins/transition

interface GwTransitionProps {
  variant?:
    | 'slidetop' //
    | 'slideright'
    | 'slidebottom_menu'
    | 'slidebottom_fade'
    | 'slideleft'
    | 'dialog'
    | 'fade'
  appear?: boolean
}

const props = withDefaults(defineProps<GwTransitionProps>(), {
  variant: 'slidetop',
  appear: true,
  duration: 220,
})
</script>

<template>
  <transition
    :name="`gwtr_${props.variant}`"
    :appear
  >
    <!-- :duration="{ enter: 500, leave: 800 }" -->
    <!-- :css="false" -->
    <!--
      @enter="onEnter"
      @before-enter="onBeforeEnter"
      @after-enter="onAfterEnter"
      @enter-cancelled="onEnterCancelled"
      @before-leave="onBeforeLeave"
      @leave="onLeave"
      @after-leave="onAfterLeave"
      @leave-cancelled="onLeaveCancelled" 
    -->
    <slot></slot>
  </transition>
</template>

<style lang="scss">
// https://vuejs.org/guide/built-ins/transition#css-based-transitions
.gwtr_fade-enter-active,
.gwtr_fade-leave-active {
  transition: opacity 0.21s ease;
}
.gwtr_fade-leave-to,
.gwtr_fade-enter-from {
  opacity: 0;
}

.gwtr_slidetop-leave-active,
.gwtr_slidetop-enter-active,
.gwtr_slideright-enter-active,
.gwtr_slideright-leave-active,
.gwtr_slideleft-enter-active,
.gwtr_slideleft-leave-active {
  transition: 0.21s;
}

// slidebottom_menu
.gwtr_slidebottom_menu-enter-active,
.gwtr_slidebottom_menu-leave-active {
  transition: 0.21s;
}
.gwtr_slidebottom_menu-enter-from,
.gwtr_slidebottom_menu-leave-to {
  transform: translateY(100%);
}

.gwtr_dialog-enter-from {
  .gwtr_FadeIn_item {
    opacity: 0;
  }
}
.gwtr_slidebottom_menu-enter-to {
  .gwtr_FadeIn_item {
    opacity: 1;
    transition: 0.22s;
  }
}
.gwtr_slidebottom_menu-leave-to {
  .gwtr_FadeIn_item {
    opacity: 0;
    transition: 0.22s;
  }
}

// slidebottom_fade
.gwtr_slidebottom_fade-enter-active,
.gwtr_slidebottom_fade-leave-active {
  transition: all 0.22s ease;
}
.gwtr_slidebottom_fade-leave-to,
.gwtr_slidebottom_fade-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.gwtr_slidetop-leave-to,
.gwtr_slidetop-enter-from {
  transform: translateY(-100%);
}
.gwtr_slideright-enter-from,
.gwtr_slideright-leave-to {
  transform: translateX(100%);
}

.gwtr_slideleft-enter-from,
.gwtr_slideleft-leave-to {
  transform: translateX(-100%);
}

// dialog
.gwtr_dialog-enter-active,
.gwtr_dialog-leave-active {
  transition: 0.22s;
}

.gwtr_dialog-enter-from {
  .gwtr_ScaleFadeIn_item {
    opacity: 0;
    transform: scale(0.96);
  }
  .gwtr_FadeIn_item {
    opacity: 0;
  }
}
.gwtr_dialog-enter-to {
  .gwtr_ScaleFadeIn_item {
    opacity: 1;
    transform: scale(1);
    transition: 0.22s;
  }
  .gwtr_FadeIn_item {
    opacity: 1;
    transition: 0.22s;
  }
}
.gwtr_dialog-leave-to {
  .gwtr_ScaleFadeIn_item {
    opacity: 0;
    transform: scale(0.99);
    transition: 0.22s;
  }
  .gwtr_FadeIn_item {
    opacity: 0;
    transition: 0.22s;
  }
}
</style>
